if (!customElements.get('plyr-vedio')) {
    class PlyrVideo extends HTMLElement {
        /**
         * Section settings (only part)
         */
        sectionSettings;

        /**
         * Swiper entity
         * 
         * @type {Player}
         */
        myPlayer;

        constructor() {
            super();

        }

        connectedCallback() {
            const isAutoplay = false;
            this.myPlayer = new Plyr(this.querySelector(`#plyr-vedio`), {
                autoplay: isAutoplay,
                resetOnEnd: true,
                loop: {
                    active: true,
                },
                controls: [
                    //'play-large', // The large play button in the center
                    //'restart', // Restart playback
                    //'rewind', // Rewind by the seek time (default 10 seconds)
                    // 'play', // Play/pause playback
                    //'fast-forward', // Fast forward by the seek time (default 10 seconds)
                    //'progress', // The progress bar and scrubber for playback and buffering
                    //'current-time', // The current time of playback
                    //'duration', // The full duration of the media
                    //'mute', // Toggle mute
                    //'volume', // Volume control
                    //'captions', // Toggle captions
                    //'settings', // Settings menu
                    //'pip', // Picture-in-picture (currently Safari only)
                    //'airplay', // Airplay (currently Safari only)
                    //'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
                    //'fullscreen', // Toggle fullscreen
                ],
                tooltips: {
                    controls: false,
                    seek: false,
                },
                youtube: {
                    loop: 1,
                },
                muted: true,
                //ratio: '16:9',
                quality: { default: 1080, options: [4320, 2880, 2160, 1440, 1080, 720] },
            });

            if (isAutoplay) {
                this.myPlayer.on('ready', () => {
                    // 播放视频
                    this.myPlayer.play();
                });
            }

            this.addEventListener('mouseenter', () => {
                this.myPlayer.play();
            });

            this.addEventListener('mouseleave', () => {
                this.myPlayer.pause();
            });
        }
    }

    customElements.define('plyr-vedio', PlyrVideo);
}

